/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const UpdateDirectiveBody = zod
	.object({
		description: zod.string().nullish().describe('Directive description'),
		name: zod.string().optional().describe('Directive name')
	})
	.describe('Request body for updating a directive');

export type UpdateDirectiveBody = zod.input<typeof UpdateDirectiveBody>;
export type UpdateDirectiveBodyOutput = zod.output<typeof UpdateDirectiveBody>;
